document.addEventListener('DOMContentLoaded', () => {
  // Select all inputs, textareas, and selects with data-error-message
  const inputs = document.querySelectorAll('[data-error-message]');
  const formMessages = document.querySelectorAll('.form__message');

  // Helper to clear old error message
  function clearOldMessage(input) {
    formMessages.forEach((message) => {
      message.classList.remove('form__message--success');
    });

    input.classList.remove('input-invalid');
    const inputID = input.getAttribute('id');
    const inputWrap = input.closest('.input-wrap');
    const oldMessageEl = inputWrap.querySelector(`[data-error-for="${inputID}"]`);
    if (oldMessageEl) {
      inputWrap.removeChild(oldMessageEl);
    }
    if (inputWrap) {
      inputWrap.classList.remove('input-invalid');
    }
  }

  // Attach listeners to each input
  inputs.forEach((input) => {
    if (input.disabled) return;

    input.addEventListener('invalid', (e) => {
      e.preventDefault();
      const inputWrap = input.closest('.input-wrap');
      const message = input.dataset.errorMessage;
      const inputID = input.getAttribute('id');

      clearOldMessage(input);
      input.classList.add('input-invalid');

      if (inputWrap) inputWrap.classList.add('input-invalid');

      const messageEl = document.createElement('div');
      messageEl.setAttribute('data-error-for', inputID);
      messageEl.classList.add('input-error');
      messageEl.textContent = message;
      inputWrap.appendChild(messageEl);
      // targetParent.insertBefore(messageEl, input.nextSibling);
    });

    // Remove error on input/change
    input.addEventListener('input', (event) => {
      clearOldMessage(event.target);
    });

    input.addEventListener('change', (event) => {
      clearOldMessage(event.target);
    });
  });
});
